import React, { lazy, Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentLanguage } from '../selectors';
import { getAvailableLanguages, getCanChangeLanguage } from 'modules/auth/selectors';
import PropTypes from 'prop-types';
import { setCurrentLanguage } from '../actions';
import { DEFAULT_LANG } from 'constants/language';
import { useTranslation } from 'react-i18next';
import changeLanguage from 'utils/changeLanguage';

const LanguageToggle = lazy(() =>
  import('modules/common/LanguageToggle/containers/LanguageToggleContainer'),
);

const AppLanguageToggleContainer = ({ minimized }) => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(getCurrentLanguage);
  const {
    i18n: { language },
  } = useTranslation();
  const languages = useSelector(getAvailableLanguages);
  const canChangeLanguage = useSelector(getCanChangeLanguage);

  useEffect(() => {
    if (currentLanguage && languages.length && !languages.includes(currentLanguage)) {
      const lang = languages.includes(DEFAULT_LANG) ? DEFAULT_LANG : languages[0];
      if (currentLanguage !== lang) {
        changeLanguage(lang);
        dispatch(setCurrentLanguage(lang));
      }
    } else if (!currentLanguage && language) {
      dispatch(setCurrentLanguage(language));
    }
  }, [dispatch, currentLanguage, languages, language]);

  return canChangeLanguage ? (
    <Suspense fallback="">
      <LanguageToggle minimized={minimized} />
    </Suspense>
  ) : null;
};

AppLanguageToggleContainer.propTypes = {
  minimized: PropTypes.bool,
};

export default AppLanguageToggleContainer;
